import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import PersonFormValidation from "../validation/forms/personFormValidator";
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import FormSelectItemValidation from "../validation/forms/formSelectItemValidation";

const PersonForm =  (props) =>{
  const {submitPerson, handleSubmit, roles, departments, person, handleCancel, changePersonState} = props;
  return (
      <form onSubmit={handleSubmit(submitPerson)}>
        <div className={'form-group'}>
          <Field name="username" label={'Username'} component={RenderTextField} type="text" required fullWidth/>
        </div>
        <div className={'form-group'}>
          <Field name="email" label={'Email'} component={RenderTextField} type="email" required fullWidth/>
        </div>
        <div className={'form-group'}>
          <Field
            validate={FormSelectItemValidation}
            name="roleId"
            label={'Role'}
            component={RenderSelectField}
            required
            fullWidth>
            {
              roles.map(role => (
                <MenuItem value={role.id} key={role.id}>{role.name}</MenuItem>
              ))
            }
          </Field>
        </div>
        <div className={'form-group'}>
          <Field
            validate={FormSelectItemValidation}
            name="departmentId"
            label={'Department'}
            component={RenderSelectField}
            required
            fullWidth>
            {
              departments.map( department => (
                <MenuItem value={department.id} key={department.id}>{department.name}</MenuItem>
              ))
            }
          </Field>
        </div>
        {
          !person.id && (
            <div className={'form-group'}>
              <Field name="password" label={'Password'} type="password" component={RenderTextField} required fullWidth/>
            </div>
          )
        }
        <div className={'form-group'}>
          <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
            {person.id?'Edit':'Create'}
          </Button>
          <Button onClick={handleCancel} variant="contained" color="secondary" className={'mr-3'}>
            {'Cancel'}
          </Button>
          {person.id && (
            <Button
              onClick={() => changePersonState({key: 'isPasswordModalOpen', value: true})}
              variant="outlined"
              color="secondary"
            >
              {'change password'}
            </Button>
          )}
        </div>
      </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'login',
  validate: PersonFormValidation,
})(PersonForm);



// WEBPACK FOOTER //
// ./src/components/person/personForm.js